import React, { useState, useEffect } from 'react';
import { FileCode, Save, Loader, Check } from 'lucide-react';
import { db } from '../../../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import '../AdminPanel.css';

const ScriptsSection = () => {
    const [scripts, setScripts] = useState({
        headerScripts: '',
        footerScripts: ''
    });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [saved, setSaved] = useState(false);

    useEffect(() => {
        const fetchScripts = async () => {
            try {
                const docRef = doc(db, 'settings', 'scripts');
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setScripts(docSnap.data());
                }
            } catch (error) {
                console.error("Error fetching scripts:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchScripts();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setScripts(prev => ({ ...prev, [name]: value }));
        setSaved(false);
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            await setDoc(doc(db, 'settings', 'scripts'), scripts);
            setSaved(true);
            setTimeout(() => setSaved(false), 3000);
        } catch (error) {
            console.error("Error saving scripts:", error);
            alert("Failed to save scripts.");
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div className="panel active"><div className="p-10 text-center text-muted">Loading scripts...</div></div>;

    return (
        <div className="panel active">
            <div className="page-hdr">
                <div className="page-hdr-left">
                    <div className="eyebrow">Development</div>
                    <h1>Scripts & Tags <span>.</span></h1>
                </div>
                <div className="page-hdr-actions">
                    <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
                        {saving ? <Loader size={14} className="animate-spin" /> : saved ? <Check size={14} /> : <Save size={14} />}
                        {saving ? 'Saving...' : saved ? 'Saved!' : 'Save Scripts'}
                    </button>
                </div>
            </div>

            <div className="card" style={{ marginBottom: '20px' }}>
                <div className="card-hdr">
                    <div className="card-hdr-title"><FileCode size={14} style={{ display: 'inline', marginRight: '8px' }} /> Header Scripts (Head)</div>
                </div>
                <div className="card-body" style={{ padding: 0 }}>
                    <textarea
                        name="headerScripts"
                        value={scripts.headerScripts}
                        onChange={handleChange}
                        spellCheck="false"
                        placeholder="<!-- Google Tag Manager -->&#10;<script>...</script>"
                        style={{
                            width: '100%', minHeight: '200px', background: 'var(--bg)', color: 'var(--text2)',
                            fontFamily: 'monospace', fontSize: '12px', border: 'none', padding: '16px', outline: 'none', resize: 'vertical'
                        }}
                    />
                </div>
            </div>

            <div className="card">
                <div className="card-hdr">
                    <div className="card-hdr-title"><FileCode size={14} style={{ display: 'inline', marginRight: '8px' }} /> Footer Scripts (Body End)</div>
                </div>
                <div className="card-body" style={{ padding: 0 }}>
                    <textarea
                        name="footerScripts"
                        value={scripts.footerScripts}
                        onChange={handleChange}
                        spellCheck="false"
                        placeholder="<script src='...'></script>"
                        style={{
                            width: '100%', minHeight: '200px', background: 'var(--bg)', color: 'var(--text2)',
                            fontFamily: 'monospace', fontSize: '12px', border: 'none', padding: '16px', outline: 'none', resize: 'vertical'
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default ScriptsSection;
